"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var prosemirror_state_1 = require("prosemirror-state");
var prosemirror_history_1 = require("prosemirror-history");
var dom_1 = require("./dom");
var event_1 = require("./event");
var formatter = __importStar(require("./formatter"));
var query_1 = require("./command/query");
var state_1 = require("./command/state");
var format_1 = require("./command/format");
var basic_ctrl_1 = require("./basic/basic-ctrl");
var shortcut_plugin_1 = require("./basic/text-shortcut/shortcut-plugin");
var util_1 = require("./libs/util");
var behavior_1 = require("./basic/keymap/behavior");
var shadow_1 = require("./command/shadow");
var const_1 = require("./const");
var prose_util_1 = require("./libs/prose-util");
var SylApi = /** @class */ (function () {
    function SylApi(configurator, options) {
        var _this = this;
        this.command = {};
        this.addCommand = function (name, commandObj) {
            if (!name)
                return;
            var editor = _this;
            _this.command[name] = Object.keys(commandObj).reduce(function (command, commandName) {
                command[commandName] = util_1.Utils.warpCommand(editor, commandObj[commandName]);
                return command;
            }, {});
        };
        this.listenBlur = function () {
            _this.configurator.emit(event_1.EventChannel.LocalEvent.ON_BLUR);
        };
        this.listenFocus = function () {
            _this.configurator.emit(event_1.EventChannel.LocalEvent.ON_FOCUS);
        };
        this.getSelection = function () {
            // anchor, head 可以表现出选择时的方向信息
            var _a = prose_util_1.getRealFromTo(_this.view.state.selection), from = _a.from, to = _a.to;
            return {
                index: from,
                length: to - from
            };
        };
        var configuration = configurator.configuration;
        this.configurator = configurator;
        this.options = options;
        this.root = configuration.mount;
        this.view = configuration.view;
        this.configurator.install(this, options.modules);
        this.domParser = this.constructParser();
        this.view.dom.addEventListener('blur', this.listenBlur);
        this.view.dom.addEventListener('focus', this.listenFocus);
    }
    SylApi.prototype.constructParser = function () {
        var _this = this;
        var domParse = dom_1.DOMParser.fromSchema(this.view.state.schema);
        var originParseSlice = domParse.parseSlice.bind(domParse);
        domParse.parseSlice = function (dom, _option) {
            var keepWhiteSpace = _this.configurator.configuration.basicConfiguration.keepWhiteSpace;
            var option = _option;
            if (!option)
                option = {};
            if (keepWhiteSpace !== undefined) {
                option.preserveWhitespace = keepWhiteSpace;
            }
            formatter.handleDOMSpec(dom);
            var slice = originParseSlice(dom, option);
            formatter.removeBrInEnd(slice);
            return slice;
        };
        return domParse;
    };
    Object.defineProperty(SylApi.prototype, "renderType", {
        get: function () {
            return this.configurator.configuration.store.get('renderType');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SylApi.prototype, "length", {
        get: function () {
            return this.view.state.doc.content.size;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SylApi.prototype, "isEmpty", {
        get: function () {
            return this.length === 2;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SylApi.prototype, "text", {
        get: function () {
            return this.getText();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SylApi.prototype, "isFocused", {
        get: function () {
            return this.view.hasFocus();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SylApi.prototype, "undoable", {
        get: function () {
            var state = this.view.state;
            return behavior_1.undo(state);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SylApi.prototype, "redoable", {
        get: function () {
            var state = this.view.state;
            return prosemirror_history_1.redo(state);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SylApi.prototype, "editable", {
        get: function () {
            // @ts-ignore
            return this.view.editable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SylApi.prototype, "shortcutable", {
        get: function () {
            // @ts-ignore
            return this.view.state.config.pluginsByKey[shortcut_plugin_1.SHORTCUT_KEY.key].enable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SylApi.prototype, "isDestroy", {
        get: function () {
            // @ts-ignore
            return !this.view.docView;
        },
        enumerable: true,
        configurable: true
    });
    SylApi.prototype.onError = function (err, args) {
        return this.configurator.configuration.onError(err, args);
    };
    // index编辑器中的位置，length指文本长度
    SylApi.prototype.getText = function (range) {
        try {
            var doc = this.view.state.doc;
            var from_1 = 0;
            var to = doc.nodeSize - 2;
            var length_1;
            if (range) {
                from_1 = range.index;
                to = Math.min(range.index + range.length, to);
                length_1 = range.length;
            }
            var textRes_1 = '';
            doc.nodesBetween(from_1, to, function (node, nodePos) {
                if (node.inlineContent) {
                    var startPos_1 = nodePos + 1;
                    node.content.forEach(function (_node) {
                        if (startPos_1 > from_1 || startPos_1 + _node.nodeSize > from_1) {
                            var text = _node.isText ? _node.textContent : _node.type.spec.getText ? _node.attrs.text : '';
                            if (startPos_1 < from_1)
                                text = text.substr(from_1 - startPos_1);
                            textRes_1 += text;
                        }
                        startPos_1 += _node.nodeSize;
                    });
                }
            });
            return textRes_1.substr(0, length_1);
        }
        catch (e) {
            console.error(e);
            this.onError(e, arguments);
            return '';
        }
    };
    SylApi.prototype.setFormat = function (format, option) {
        if (option === void 0) { option = {}; }
        try {
            var _a = this.view, state_2 = _a.state, dispatch = _a.dispatch;
            var range_1;
            if (option.index !== undefined && option.length !== undefined) {
                range_1 = { from: option.index, to: option.index + option.length };
            }
            var tr_1 = state_2.tr;
            Object.keys(format).map(function (type) {
                tr_1 = format_1.formatSelection(type, format[type], range_1)(state_2, tr_1);
            });
            dispatch(tr_1);
            option.focus !== false && this.focus();
        }
        catch (err) {
            this.onError(err, arguments);
        }
    };
    SylApi.prototype.insert = function (nodeInfo, index) {
        try {
            return state_1.insert(this.view, nodeInfo, index);
        }
        catch (err) {
            this.onError(err, arguments);
        }
    };
    SylApi.prototype.insertText = function (text, format, index) {
        if (format === void 0) { format = {}; }
        try {
            return state_1.insertText(this.view, text, format, index);
        }
        catch (err) {
            this.onError(err, arguments);
        }
    };
    SylApi.prototype.insertCard = function (type, attrs, index) {
        return this.insert({ type: type, attrs: attrs }, index);
    };
    SylApi.prototype.insertInlineCardWithPara = function (type, attrs, index) {
        return this.insert({ type: 'paragraph', content: [{ type: type, attrs: attrs }] }, index);
    };
    SylApi.prototype.replace = function (nodeInfo, replaceOption) {
        try {
            return state_1.replace(this.view, nodeInfo, replaceOption);
        }
        catch (err) {
            this.onError(err, arguments);
        }
    };
    SylApi.prototype.replaceCard = function (type, attrs, index) {
        return this.replace({ type: type, attrs: attrs }, index);
    };
    SylApi.prototype.delete = function (index, length, option) {
        if (option === void 0) { option = {}; }
        try {
            return state_1._delete(this.view, __assign({ index: index, length: length }, option));
        }
        catch (err) {
            this.onError(err, arguments);
        }
    };
    SylApi.prototype.deleteCard = function (index) {
        this.delete(index, const_1.LEAF_NODE_SIZE);
    };
    SylApi.prototype.on = function (event, handler) {
        this.configurator.on(event, handler);
    };
    SylApi.prototype.off = function (event, handler) {
        this.configurator.off(event, handler);
    };
    // TODO: 错误参数返回
    SylApi.prototype.setSelection = function (config) {
        var index = config.index, _a = config.length, length = _a === void 0 ? 0 : _a, _b = config.scrollIntoView, scrollIntoView = _b === void 0 ? true : _b;
        var _c = this.view, state = _c.state, dispatch = _c.dispatch;
        var doc = state.doc;
        var from = index;
        if (from < 0) {
            from = 0;
        }
        var to = from + length;
        if (to > doc.nodeSize - 2) {
            to = doc.nodeSize - 2;
        }
        var selection = prosemirror_state_1.TextSelection.create(doc, from, to);
        var tr = state.tr.setSelection(selection);
        dispatch(scrollIntoView === false ? tr : tr.scrollIntoView());
    };
    SylApi.prototype.blur = function () {
        this.view.dom.blur();
    };
    SylApi.prototype.enable = function () {
        var _a = this.view, state = _a.state, dispatch = _a.dispatch;
        dispatch(state.tr.setMeta(basic_ctrl_1.BSControlKey, { editable: true }));
    };
    SylApi.prototype.disable = function () {
        var _a = this.view, state = _a.state, dispatch = _a.dispatch;
        dispatch(state.tr.setMeta(basic_ctrl_1.BSControlKey, { editable: false }));
    };
    SylApi.prototype.enableShortcut = function () {
        var _a = this.view, state = _a.state, dispatch = _a.dispatch;
        dispatch(state.tr.setMeta(shortcut_plugin_1.SHORTCUT_KEY, true));
    };
    SylApi.prototype.disableShortcut = function () {
        var _a = this.view, state = _a.state, dispatch = _a.dispatch;
        dispatch(state.tr.setMeta(shortcut_plugin_1.SHORTCUT_KEY, false));
    };
    SylApi.prototype.focus = function () {
        this.view.focus();
    };
    SylApi.prototype.undo = function () {
        var _a = this.view, dispatch = _a.dispatch, state = _a.state;
        var res = behavior_1.undo(state, dispatch);
        // 为了更新工具栏
        this.configurator.emit(event_1.EventChannel.LocalEvent.SELECTION_CHANGED);
        return res;
    };
    SylApi.prototype.redo = function () {
        var _a = this.view, dispatch = _a.dispatch, state = _a.state;
        var res = prosemirror_history_1.redo(state, dispatch);
        // 为了更新工具栏
        this.configurator.emit(event_1.EventChannel.LocalEvent.SELECTION_CHANGED);
        return res;
    };
    SylApi.prototype.uninstall = function () {
        var configuration = this.configurator.configuration;
        configuration.view.dom.removeEventListener('blur', this.listenBlur);
        this.configurator.uninstall();
    };
    // experimental function
    SylApi.prototype.getContent = function () {
        return this.view.state.toJSON();
    };
    // experimental function
    SylApi.prototype.setContent = function (value) {
        try {
            var state = prosemirror_state_1.EditorState.fromJSON(this.view.state, value);
            this.view.updateState(state);
        }
        catch (err) {
            this.onError(err, arguments);
        }
    };
    /**
     * 设置编辑器内容，传入html字符串。
     * allowUndo指是否允许撤销，默认为false；
     * silent指是否触发text-change事件，默认为true；
     * mergeEmpty指是否合并连续空段落与连续换行，默认为true。
     * 注意silent为true时allowUndo必为false。
     */
    SylApi.prototype.setHTML = function (value, options) {
        if (value === void 0) { value = ''; }
        if (options === void 0) { options = {}; }
        try {
            var config = Object.assign({
                allowUndo: false,
                silent: true,
                mergeEmpty: true,
                keepWhiteSpace: false
            }, options);
            var view = this.view;
            var docNode = formatter.parseHTML(value, this, config);
            if (config.allowUndo || config.silent === false) {
                // 支持撤销 setHTML 操作
                view.dispatch(view.state.tr.replace(0, view.state.doc.content.size, docNode.slice(0)));
            }
            else {
                var newState = prosemirror_state_1.EditorState.create({
                    schema: view.state.schema,
                    storedMarks: view.state.storedMarks,
                    plugins: view.state.plugins,
                    doc: docNode
                });
                view.updateState(newState);
            }
        }
        catch (err) {
            this.onError(err, arguments);
        }
    };
    /**
     * 获取编辑器html内容。
     * layerType指获取在ViewMap中或者controllerProps.layers中配置的layer内容，默认为‘template'；
     * mergeEmpty指是否合并连续空段落与连续换行，默认为false。
     */
    SylApi.prototype.getHTML = function (config) {
        if (config === void 0) { config = { layerType: 'template', mergeEmpty: false }; }
        try {
            if (config.layerType) {
                this.configurator.emit(event_1.EventChannel.LocalEvent.SWITCH_LAYER, config.layerType);
            }
            return formatter.formatGetHTML(this.view.dom, config, this.configurator.getSylPlugins());
        }
        catch (e) {
            this.onError(e, arguments);
        }
    };
    SylApi.prototype.getExistNodes = function (nodeName) {
        try {
            return query_1.getExistNodes(this.view.state.doc, nodeName);
        }
        catch (err) {
            this.onError(err, arguments);
            return [];
        }
    };
    SylApi.prototype.getExistMarks = function (markName) {
        try {
            return query_1.getExistMarks(this.view.state, markName);
        }
        catch (err) {
            this.onError(err, arguments);
            return [];
        }
    };
    SylApi.prototype.checkHasContentBefore = function (pos) {
        try {
            return query_1.checkHasContentBefore(this.view.state.doc, pos);
        }
        catch (err) {
            this.onError(err, arguments);
            return true;
        }
    };
    SylApi.prototype.update = function (attrs, updateOption) {
        try {
            return state_1.update(this.view, attrs, updateOption);
        }
        catch (err) {
            this.onError(err, arguments);
        }
    };
    SylApi.prototype.updateCardAttrs = function (index, attrs, updateOption) {
        if (updateOption === void 0) { updateOption = {}; }
        return this.update(attrs, __assign({ index: index }, updateOption));
    };
    SylApi.prototype.getFormat = function (range) {
        try {
            return format_1.getFormat(this.view, range);
        }
        catch (err) {
            this.onError(err);
            return {};
        }
    };
    SylApi.prototype.clearFormat = function () {
        var result = format_1.clearFormat(this.view);
        // 为了更新工具栏
        this.configurator.emit(event_1.EventChannel.LocalEvent.SELECTION_CHANGED);
        return result;
    };
    SylApi.prototype.nodesBetween = function (walker, range) {
        var _a = this.view.state, doc = _a.doc, selection = _a.selection;
        var _b = prose_util_1.getRealFromTo(selection), from = _b.from, to = _b.to;
        if (range) {
            from = range.index;
            to = range.index + range.length;
        }
        else if (selection.ranges.length > 1) {
            var ranges = selection.ranges.sort(function (a, b) { return a.$from.pos - b.$from.pos; });
            from = ranges[0].$from.pos;
            to = ranges[ranges.length - 1].$from.pos;
        }
        doc.nodesBetween(from, to, walker);
    };
    SylApi.prototype.getCursorNode = function () {
        return query_1.getCursorNode(this.view);
    };
    SylApi.prototype.getShadows = function (key, index, length) {
        var start = index === undefined ? undefined : index;
        var end = start === undefined || length === undefined ? undefined : start + length;
        return shadow_1.getShadows(this.view.state, key, start, end);
    };
    SylApi.prototype.insertShadow = function (data, inline) {
        if (inline === void 0) { inline = false; }
        var _a = this.view, state = _a.state, dispatch = _a.dispatch;
        var index = data.index || data.pos;
        var pos = index === undefined ? this.getSelection().index : index;
        shadow_1.insertShadow(state, dispatch, __assign(__assign({}, data), { pos: pos }), inline);
    };
    SylApi.prototype.removeShadow = function (key) {
        var _a = this.view, state = _a.state, dispatch = _a.dispatch;
        var shadowInfo = shadow_1.removeShadow(state, dispatch, key);
        if (!shadowInfo)
            return;
        var from = shadowInfo.from, to = shadowInfo.to, spec = shadowInfo.spec;
        return { index: from, length: to - from, spec: spec };
    };
    SylApi.prototype.appendShadow = function (data, inline) {
        var _a;
        if (inline === void 0) { inline = false; }
        var _b = this.view, state = _b.state, dispatch = _b.dispatch;
        var shadowData = {
            from: data.index,
            to: data.length + data.index,
            attrs: __assign((_a = {}, _a[formatter.IG_TAG] = 'true', _a), data.attrs),
            spec: data.spec
        };
        shadow_1.appendShadow(state, dispatch, shadowData, inline);
    };
    return SylApi;
}());
exports.SylApi = SylApi;
//# sourceMappingURL=api.js.map